export const WALLET_MAIN = 'MAIN'
export const WALLET_REWARD = 'REWARD'

const WALLET_LABELS = {
  [WALLET_MAIN]: 'Ví chơi',
  [WALLET_REWARD]: 'Ví thưởng',
}

export const getWalletLabel = (wallet) => WALLET_LABELS[wallet] || wallet || ''

export const WALLET_OPTIONS = [
  { value: '', label: 'Tất cả' },
  { value: WALLET_MAIN, label: WALLET_LABELS[WALLET_MAIN] },
  { value: WALLET_REWARD, label: WALLET_LABELS[WALLET_REWARD] },
]
